<template>
  <div class="recommend">
    <div class="left">
      <div class="flex">
        <div class="title flex">
          <span>推荐专业
            <select name="one" style="width: 100px;" @change="changeLevel()" v-model="level">
              <option value="" disabled selected>请选择</option>
              <option v-for="item in options.level_list" :value="item.value">
                {{item.label}}
              </option>
            </select>
            <select name="two" style="width: 100px;" v-model="cate" @change="changeLevel()">
              <option value="" disabled selected>请选择</option>
              <option v-for="item1 in options.cate_list" :value="item1.value">{{item1.label}}</option>
            </select>
            <!-- <el-select v-model="value" placeholder="请选择" size='mini' style="width: 150px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
          </span>

        </div>
        <div class="more" @click="jump('/specialtyList')"><span>更多</span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="block">
        <el-carousel indicator-position="outside" height="250px">
          <el-carousel-item :key="item" v-for="(item1,index) in data">
            <ul class="flex">
              <li v-for="(item,index) in item1" @click="jump(`/specialtyDetail?id=${item.major_code}`)">
                <p style="font-size: 20px;color: #FFA200;">{{item.major_name}}</p>
                <p style="margin: 20px 0;background-color: #F2F2F2;color: #999999;padding: 5px;border-radius: 20px;">
                  {{item.major_type}}
                </p>
                <p>专业代码:{{item.major_code}}</p>
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>

  </div>
</template>

<script>
  import {
    jump
  } from '../../../static/function.js'
  export default {
    data() {
      return {
        data: [],
        school: [],
        options: [],
        level: '',
        cate: ""
      }
    },
    created() {
      this.$http.indexRecommend({
        type: 2
      }).then(res => {
        this.data = res.data.list
      })
      this.$http.getIndexRecommend({
        type: 2
      }).then(res => {
        console.log(res)
        this.options = res.data
      })
    },
    methods: {
      changeLevel(event) {
        this.data = []
        let params = {
          level: this.level,
          cate_id: this.cate,
          type: 2
        }
        this.$http.indexRecommend(params).then(res => {
          this.data = res.data.list
        })
        console.log(this.data)
      },
      goDetail(item) {
        console.log(item)
        this.$router.push('/specialtyDetail?id=' + item.major_code)
      },
      getData() {
        let arr = Array(4)
        let arr1 = [this.data, ...this.data1]
        this.data.concat(this.data1)
        this.data
      }
    }
  }
</script>

<style lang="scss" scoped>
  $color:'#C10B17';

  ul {
    margin-top: 30px;
  }

  .list li {
    /* height: 40px; */
  }

  li {
    /* width: 100%; */
    /*  height: 140px; */
    margin-bottom: 13px;
    text-align: left;
  }

  li:hover {
    cursor: pointer;
    box-shadow: 0px 3px 29px 3px rgba(0, 0, 0, 0.03);
  }

  .hot {
    color: #FFA200;
  }

  .rank {
    width: 20px;
    height: 20px;
    background: #FF0000;
    display: inline-block;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
    border-radius: 5px;
  }

  .rank1 {
    background: #FF7F7F;
  }

  .rank2 {
    background: #FFCCCC;
  }

  .rank3 {
    background: #F2F2F2;
  }

  .more {
    display: inline-block;
    float: right;
  }

  .right {
    width: 300px;
    float: left;
    margin-top: 33px;
    margin-left: 40px;
  }

  .block {
    margin: 11px 0 0 26px;
  }

  .left {
    margin-top: 31px;
    /* width: 100%; */
    margin-right: 31px;
  }

  .title {
    /* width: 100px; */
    position: relative;
    line-height: 18px;
    margin-left: 30px;
  }

  .title1 {
    /*  width: 200px; */
    position: relative;
    line-height: 18px;
  }

  .title::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: $color;
  }

  .title1::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: $color;
  }

  .recommend {
    width: 1280px;
    /* height: 300px; */
    background: #FFFFFF;
    margin: 22px auto;
    overflow: hidden;
    box-shadow: 0px 1px 29px 1px rgba(0, 0, 0, 0.03);
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .flex {
    justify-content: space-between;
  }

  .flex li {
    padding: 15px;
    list-style: none;
    text-align: center;
  }

  img {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
    margin: 40px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/zhuanye.vue